// **تذكير المرفقات** (قرار المالك: «لو نسي مرفقات الحجز، عاوز رسالة تظهرله تفكّره وتقوله:
// ارفع صورة جواز السفر والتذكرة والشات اللي بينك وبين العميل — وفهّمه إن ده في مصلحته
// وقت الاختلاف لو لا قدّر الله حصل»).
//
// المرفقات إجبارية أصلًا (paymentRules)، لكن سطرًا أحمر صغيرًا يُقرأ عقوبةً ويُتجاوز.
// فحين يضغط «إنشاء الحجز» بلا ملفّ واحد تفتح هذه النافذة: ماذا يرفع بالضبط، ولماذا هو
// في مصلحته هو قبل الشركة — ثم زرٌّ واحد يعيده إلى قسم المرفقات.
import { Modal } from '../../components/ui.tsx';

export const REMINDER_DOCS = ['صورة جواز السفر', 'التذكرة', 'الشات اللي بينك وبين العميل'] as const;

export function AttachmentsReminder({ onClose }: { onClose: () => void }) {
  return (
    <Modal title="📎 نسيت مرفقات الحجز؟" size="sm" onClose={onClose}>
      <div className="space-y-3 text-base leading-8 text-ink-800">
        <p>قبل ما تحفظ الحجز، ارفع:</p>
        <ul className="space-y-1 rounded-lg bg-amber-50 px-4 py-3 font-semibold text-amber-950">
          {REMINDER_DOCS.map(d => <li key={d}>• {d}</li>)}
        </ul>
        <p>
          ده <b>في مصلحتك أنت الأول</b>: لو حصل خلاف مع العميل — لا قدّر الله — الورق ده هو اللي بيثبت
          إيه اللي اتفقتوا عليه وإيه اللي اتنفّذ. من غيره الكلام بيبقى كلام، ومعاه حقّك محفوظ.
        </p>
        <button type="button" className="btn-primary w-full py-2.5 text-base" onClick={onClose}>
          تمام — هرفعهم دلوقتي
        </button>
      </div>
    </Modal>
  );
}
